// import { t } from "element-plus/lib/locale";
import flowapis  from "../../api/flow";
import BankAudit from "../BankAudit/index.vue";
import LoanDetail from "../LoanDetail/index.vue";
import BankBossAudit from "../BankBossAudit/index.vue"
import LoanAudit from "../LoanAudit/index.vue"
import LoanRiskAudit from "../LoanRiskAudit/index.vue"
import LoanMasterInputMoney from "../LoanMasterInputMoney/index.vue"
import LoanContract from "../LoanContract/index.vue"
import LoanFzjlAudit from "../LoanFzjlAudit/index.vue"
import LoanZjlAudit from "../LoanZjlAudit/index.vue"

export default {
    name: "Flow",
    components: {
      BankAudit,
      BankBossAudit,
      LoanDetail,
      LoanAudit,
      LoanRiskAudit,
      LoanMasterInputMoney,
      LoanContract,
      LoanFzjlAudit,
      LoanZjlAudit
    },
    data() {
        return {
            detailVisible:false,
            userVisible:false,
            dataDetail:{},
            query: {
                keyword: "",
                state:"1",
                pageIndex: 1,
                pageSize: 10
            },
            tableCols:[
                {
                    "prop": "Id",
                    "label": "流程编号",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "Name",
                    "label": "申请人",
                    "width": "100",
                    "align": "center"
                },
                {
                  "prop": "BankName",
                  "label": "银行",
                  "width": "",
                  "align": "center"
              },
                {
                    "prop": "Money",
                    "label": "金额/万元",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "FinalMoney2",
                    "label": "担保部长确认金额/万元",
                    "align": "center"
                },
                {
                  "prop": "State",
                  "label": "当前节点",
                  "width": "140",
                  "align": "center"
                },
                {
                    "prop": "UpdateTime",
                    "label": "最后更新时间",
                    "width": "160",
                    "align": "center"
                },
                // {
                //   "prop": "Type",
                //   "label": "类型",
                //   "width": "160",
                //   "align": "center"
                // },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "",
                    "align": "center"
                }
            ],
            tableData:[],
            pageTotal: 0,
            scrollHeight:400,
            type:1,//1银行分配2银行转交3担保分配4担保转交
            userList:[],
            userCols:[
              {
                "prop": "WxNickName",
                "label": "微信名",
                "width": "",
                "align": "center"
            },
              {
                  "prop": "UserName",
                  "label": "用户名",
                  "width": "100",
                  "align": "center"
              },
              {
                "prop": "Tel",
                "label": "联系电话",
                "width": "140",
                "align": "center"
              },
              {
                  "prop": "Operation",
                  "label": "操作",
                  "width": "300",
                  "align": "center"
              }
          ],
        };
    },
    beforeCreate: function () {
      let meta = this.$route.meta
      if(meta&&meta.permBtns.length>0){
        this.permBtns = meta.permBtns
      }
    },
    created() {
      // this.getData();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
        getData(){
          let param=this.query;
          flowapis.getFlowList(param).then(res => {
            this.tableData=res.list;
            if(this.tableData&&this.tableData.length>0){
              for(let i=0;i<this.tableData.length;i++){
                if(this.tableData[i].FinalMoney&&this.tableData[i].FinalMoney!==0){
                  this.tableData[i].FinalMoney2 = this.tableData[i].FinalMoney*1.0/1000000
                }
              }
            }
            this.$data.pageTotal=res.count
          });
        },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        handleEmpty(){
           this.$data.query={
            keyword: "",
            pageIndex: 1,
            pageSize: 10}
        },

        // 终止操作
        handleDelete(row) {
          var str="长时间未缴费";
          if(row.Route==11)str="长时间未签署合同";
      
          this.$confirm("终止原因："+str+'。删除后不可恢复, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
          var param={
            Id:row.Id,
            Route:13,
            RefuseType:str,
            State:4
          }
          this.updateFlow(param);

        }).catch(() => {
          this.$message({
              type: 'info',
              message: '已取消操作'
            });
        });
        },
        handleContract(row) {
          let that = this
          // var param=
          // {
          //   Id:row.Id,
          //   Route:11
          // }
          // this.updateFlow(param);
          that.$refs.loanContract.onChangeOpen()
          that.$refs.loanContract.queryData(row)
        },
        handleFzjlOk(row){
          let that = this
          that.$refs.loanFzjlAudit.onChangeOpen()
          that.$refs.loanFzjlAudit.queryData(row)
        },
        handleZjlOk(row){
          let that = this
          that.$refs.loanZjlAudit.onChangeOpen()
          that.$refs.loanZjlAudit.queryData(row)
        },
        handleView(row) {
          // this.detailVisible=true;
          // this.dataDetail=row;
          let that = this
          that.$refs.loanDetail.onChangeOpen()
          that.$refs.loanDetail.queryData(row)
        },
        // 银行经理审核
        handleBankAudit(row) {
          let that = this
          if(row){
            that.$refs.bankAudit.onChangeOpen()
            that.$refs.bankAudit.queryData(row)
          }
        },
        // 银行总负责人审核
        handleBankBossAudit(row){
          let that = this
          if(row){
            that.$refs.bankBossAudit.onChangeOpen()
            that.$refs.bankBossAudit.queryData(row)
          }
        },

        // 银行审核完回调函数，用于重新查询列表
        bankAuditSucess(){
          this.getData();
        },
    
        //更新流程
        updateFlow(data){
          flowapis.updateFlow(data).then(res => {
                         if(res.code){
                          this.$message.success("操作成功");
                            this.refreshList();
                            this.$data.detailVisible=false;
                            this.$data.userVisible=false;
                         }else if(res.code==false){
                           this.$message.error(res.msg);
                         }
          });
       },
       //仅仅更新经理人选
       updateFlowMananger(data){
        flowapis.updateFlowMananger(data).then(res => {
                       if(res){
                        this.$message.success("操作成功");
                          this.refreshList();
                          this.$data.userVisible=false;
                       }else{
                         this.$message.error("操作失败");
                       }
     });
     },
     handleAccept(row,type) {
      var param=
      {
        Id:row.Id,
        type:type
      }
      flowapis.receiveFlow(param).then(res => {
        if(res){
         this.$message.success("操作成功");
           this.refreshList();
           this.$data.userVisible=false;
        }else{
          this.$message.error("操作失败");
        }
});

    },
      //改变经理人选
      handleTransfer(row,type) {
        this.type=type;
        this.dataDetail=row;
        this.getUserList();
        this.userVisible=true;
      },
      //获取经理列表
      getUserList(){
        var type=this.type;
        let param={
          type:type,
          bankName:this.dataDetail.BankName,
          bankSiteName:this.dataDetail.BankSiteName
        }
        flowapis.getUserListForAudit(param).then(res => {
          this.userList=res;
      });
      },
      //获取经理选中情况
      getUserState(row){
        var UserID="";   
        var type=this.type;
        if(type==3||type==4)UserID=this.dataDetail.SixUser;
        else UserID=this.dataDetail.ThirdUser;
        if(row.UserID==UserID)return true;
        else return false;
        
      },
      //选择用户
      chooseUser(row){
        var param={};
        var type=this.type;
        if(type==3||type==4)
        param=
        {
          Id:this.dataDetail.Id,
          Route:5,
          SixUser:row.UserID,
        }
        else 
        param=
        {
          Id:this.dataDetail.Id,
          Route:2,
          ThirdUser:row.UserID,
        }
        if(this.type==1&&this.dataDetail.Route!=2)this.updateFlow(param);//银行分配且流程节点不等于2
        else if(this.type==3&&this.dataDetail.Route!=5)this.updateFlow(param);//担保分配且流程节点不等于5
        else{
          param.Route=this.dataDetail.Route;
          param.type=this.type;
          this.updateFlowMananger(param);
        } 
      },
        // 担保经理审核
        handleDBAudit(row) {
          let that = this
          that.$refs.loanAudit.onChangeOpen()
          that.$refs.loanAudit.queryData(row)
        },

        // 风控审核
        handleRiskDBAudit(row){
          let that = this
          that.$refs.loanRiskAudit.onChangeOpen()
          that.$refs.loanRiskAudit.queryData(row)
        },

        // 担保总负责输入金额
        handleMasterAudit(row){
          let that = this
          that.$refs.loanMasterInputMoney.onChangeOpen()
          that.$refs.loanMasterInputMoney.queryData(row)
        },

        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height2=$(".content-box .content .seach-container").height();
            var height=height1-height2-112
            this.scrollHeight = height;
          });
        },
        getTypeName(value){
          let name = ''
          if(value === 4){
            name = '线下'
          }else{
            name = '线上'
          }
          return name
        }
    },
    activated(){
      this.getData();
    }
  };
